// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RHZ-","colMin":"styles_colMin__138UZ"};